import React, {Component} from 'react';
import firebase from 'firebase/app';
import 'firebase/database';
import {EditorDialog} from '../editor-components';

/** @class EditExhibitorDialog
  * A component for editing an existing exhibitor.
  */
export default class EditExhibitorDialog extends Component {
  /** @constructor
    * Constructs a new EditexhibitorDialog instance
    */
  constructor(props) {
    super(props);
    this.state = {
      company: props.exhibitor.company || '',
      brand: props.exhibitor.brand || '',
      contact: props.exhibitor.contact || '',
      email: props.exhibitor.email || '',
      phone: props.exhibitor.phone
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
  }
  /** @method componentWillReceiveProps
    * Responds to changing props (most likely
    * when a new user has been selected).
    */
  componentWillReceiveProps(props) {
    this.setState({
      company: props.exhibitor.company || '',
      brand: props.exhibitor.brand || '',
      contact: props.exhibitor.contact || '',
      email: props.exhibitor.email || '',
      phone: props.exhibitor.phone
    });
  }
  /** @function handleChange
    * Applies user changes to the state
    * @param {InputEvent} event - the triggering event
    */
  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }
  /** @method handleSelect
    * Applies changes to the user state from a select input
    * @param {InputEvent} event - the triggering event
    */
  handleSelect(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    this.setState({
      [name]: value
    }, () => this.handleBlur());
  }
  /** @function handleBlur
    * Applies the current state to the database
    */
  handleBlur(event) {
    const target = event.target;
    const name = target.name;
    firebase.database().ref(`/exhibitors/${this.props.exhibitor.id}/${name}`).set(this.state[name]);
  }
  /** @method render
    * Renders the component
    */
  render() {
    return (
      <EditorDialog show={this.props.show} onExit={this.props.onExit}>
        <h3>Edit Exhibitor</h3>
        <p className="info-panel">
          Changes are automatically applied
        </p>
        <div className="input-group">
          <label htmlFor="company">Company</label>
          <input name="company" type="text"
            value={this.state.company}
            onChange={this.handleChange}
            onBlur={this.handleBlur}/>
        </div>
        <div className="input-group">
          <label htmlFor="brand">Brand</label>
          <input name="brand" type="text"
            value={this.state.brand}
            onChange={this.handleChange}
            onBlur={this.handleBlur}/>
        </div>
        <div className="input-group">
          <label htmlFor="contact">Contact Name</label>
          <input name="contact" type="text"
            value={this.state.contact}
            onChange={this.handleChange}
            onBlur={this.handleBlur}/>
        </div>
        <div className="input-group">
          <label htmlFor="email">Contact Email</label>
          <input name="email" type="email"
            value={this.state.email}
            onChange={this.handleChange}
            onBlur={this.handleBlur}/>
        </div>
        <div className="input-group">
          <label htmlFor="phone">Contact Phone</label>
          <input name="phone" type="phone"
            value={this.state.phone}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            pattern="[0-9]{3}[ -][0-9]{3}[ -][0-9]{4}"
            />
        </div>
      </EditorDialog>
    );
  }
}



// WEBPACK FOOTER //
// ./src/exhibitor-list/edit-exhibitor-dialog.js